// extracted by mini-css-extract-plugin
export var active = "_mb-2";
export var recordingDot = "_mb-1";
export var recordingIndicator = "_mb-0";